export const LAUNCHPAD_HUB_SPLASH_SEEN_KEY = 'attaima-launchpad-hub-splash-seen';

export function clearLaunchpadSplashSeen(): void {
  if (typeof window === 'undefined') {
    return;
  }

  localStorage.removeItem(LAUNCHPAD_HUB_SPLASH_SEEN_KEY);
}

export function isLaunchpadSplashSeen(): boolean {
  if (typeof window === 'undefined') {
    return true;
  }

  return Boolean(localStorage.getItem(LAUNCHPAD_HUB_SPLASH_SEEN_KEY));
}

export function markLaunchpadSplashSeen(): void {
  if (typeof window === 'undefined') {
    return;
  }

  localStorage.setItem(LAUNCHPAD_HUB_SPLASH_SEEN_KEY, '1');
}
